import Footer from '@alltrails/shared/components/Footer';
import { Context } from '@alltrails/shared/types/context';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { handleLanguageChange } from 'utils/language_support_util';
import CustomProvider from '../CustomProvider';

type FooterWrapperProps = {
  context: Context;
  wideFooter: boolean;
};

const FooterWrapper = ({ context, wideFooter }: FooterWrapperProps): JSX.Element => {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <Footer
      enabledLanguages={context.enabledLanguages}
      user={user}
      wideFooter={wideFooter}
      handleLanguageChange={(newLanguageRegionCode: LanguageRegionCode) => handleLanguageChange(user, newLanguageRegionCode)}
      languageRegionCode={languageRegionCode}
    />
  );
};

export default function Wrapper({ context, wideFooter }: FooterWrapperProps) {
  return (
    <CustomProvider>
      <FooterWrapper context={context} wideFooter={wideFooter} />
    </CustomProvider>
  );
}
